/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Actions from "../../../fluid/Actions/ActionFactory.js";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";

const styles = (theme) => ({
  text_field: {
    width: "100%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

class CreateScript extends Component {
  state = {
    script_name: "",
    script_name_error: "",
    script_name_helper_text: "Choose a Unique name for the Script",

    script_title: "",
    script_title_error: "",
    script_title_helper_text: "Provide a title for the Script",

    script_description: "",
    script_description_error: "",
    script_description_helper_text: "Write a description for the Script",

    script_host_name: "",
    script_host_name_error: "",
    script_host_name_helper_text: "Provide a url for the Script",

    script_location: "",
    script_location_error: "",
    script_location_helper_text: "Provide a location for the Script",

    error: false,
    error_message: null,
    errorOpen: false,
    errorInfo: {},

    script_details: null,
    edit_mode: false,
  };

  componentDidMount = () => {
    if (this.props.script_details !== null) {
      this.setScriptDetails();
    }
  };

  setScriptDetails = () => {
    let { script_details, edit_mode } = this.props;
    if (edit_mode === true) {
      this.setState(
        {
          script_details: script_details,
          edit_mode: true,
        },
        () => {
          let { script_details } = this.state;
          let script_name = script_details.name;
          let script_title = script_details.title;
          let script_description = script_details.description;
          let script_host_name = script_details.host_name;
          let script_location = script_details.script_location;
          this.setState({
            script_name,
            script_title,
            script_description,
            script_host_name,
            script_location,
          });
        }
      );
    }
  };
  handleChange = (value, state_key) => {
    this.setState(
      {
        ...this.state,
        [state_key]: value,
      },
      () => {
        console.log("Create IU State: ", this.state);
      }
    );
  };

  validateField = (field) => {
    if (this.state[field] !== "") {
      let error = false;
      this.setState({ [field + "_error"]: error });
      return true;
    } else {
      let error = true;
      this.setState({ [field + "_error"]: error });
      return false;
    }
  };

  validateAndProceed = () => {
    let script_details_create_step = {
      name: this.state.script_name,
      title: this.state.script_title,
      description: this.state.script_description,
      host_name: this.state.script_host_name,
      script_location: this.state.script_location,
    };

    let { edit_mode } = this.state;

    if (edit_mode === true) {
      let { script_details } = this.state;
      let {
        name,
        title,
        description,
        host_name,
        script_location,
      } = script_details_create_step;

      script_details.name = name;
      script_details.title = title;
      script_details.description = description;
      script_details.host_name = host_name;
      script_details.script_location = script_location;

      this.setState({ ...this.state, script_details: script_details }, () => {
        this.props.handleNext({
          script_name: this.state.script_name,
          script_details: this.state.script_details,
        });
      });
    } else {
      this.setState(
        { ...this.state, script_details: script_details_create_step },
        () => {
          this.props.handleNext({
            script_name: this.state.script_name,
            script_details: this.state.script_details,
          });
        }
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          width: "100%",
          height: this.props.maxHeight,
          backgroundColor: "#F0F0F0",
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            // height: this.props.maxHeight,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: this.state.content_height,
            maxHeight: this.state.content_height,
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <Paper
            elevation={4}
            style={{
              padding: "10px",
              width: "60%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <Typography variant="h6">Create Script</Typography>
              <Divider style={{ marginTop: "5px", marginBottom: "10px" }} />
            </div>
            <ThemeProvider theme={blue_theme}>
              <TextField
                key="script_name"
                className={classes.text_field}
                disabled={this.state.edit_mode === true}
                name="Script Name"
                defaultValue=""
                multiline={false}
                label="Script Name"
                value={this.state.script_name}
                error={this.state.script_host_name_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.script_name_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "script_name")
                }
                onBlur={() => this.validateField("script_name")}
              />

              <TextField
                key="title"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Script Title"
                defaultValue=""
                multiline={false}
                label="Script Title"
                value={this.state.script_title}
                error={this.state.script_title_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.script_title_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "script_title")
                }
                onBlur={() => this.validateField("script_title")}
              />

              <TextField
                key="script_description"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Script Description"
                defaultValue=""
                multiline={true}
                rowsMax="4"
                label="Script Description"
                value={this.state.script_description}
                error={this.state.script_description_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.script_description_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "script_description")
                }
                onBlur={() => this.validateField("script_description")}
              />

              <TextField
                key="script_host_name"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Script Host Name"
                defaultValue=""
                multiline={true}
                rowsMax="4"
                label="Script Host Name"
                value={this.state.script_host_name}
                error={this.state.script_host_name_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.script_host_name_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "script_host_name")
                }
                onBlur={() => this.validateField("script_host_name")}
              />

              <TextField
                key="script_location"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Script Location"
                defaultValue=""
                multiline={true}
                rowsMax="4"
                label="Script Location"
                value={this.state.script_location}
                error={this.state.script_location_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.script_location_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "script_location")
                }
                onBlur={() => this.validateField("script_location")}
              />

              <ThemeProvider theme={blue_theme}>
                <Button
                  style={{ marginTop: "20px" }}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={this.validateAndProceed}
                >
                  Next
                </Button>
              </ThemeProvider>
            </ThemeProvider>
          </Paper>
        </div>

        {this.state.error === true && (
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.error_message}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(CreateScript);
